export default {
        "en-US": {
        locale_short_name: "en-US",
		locale_name: "English US",
		_home: "Home",
        _search: "Search",
        _globalsearch: "Global Search",
        _helpsetsearch: "Helpset Search",
		_ok: "Ok",
		_login: "Login",
		_logout: "Logout",
        _badcredentials: "Incorrect credentials",
        _nolicense: "The Delivery Platform (KB) is not enabled on this server",
		_username: "Username",
		_password: "Password",
		_cancel: "Cancel",
        _close: "Close",
        _langauges: "Languages",
		_language: "Language",
		_changelanguage: "Change language",
		_next: "Next",
        _prev: "Previous",
        _notloggedinSummary: "You are not logged in",
        _forbidden: "Error 403: Resource Forbidden",
        _serverError: "Server Error",
        _errordialog: "Error",
        _notallowed: "The requested operation is not allowed",
        _cartdialog: "Ordering cart",
        _resultswithin: "Result within ",
        _helpsetfilter: "site filter",
        _searchresultsfor: "Search results for ",
        _allresults: "All results",
        _downloadfileinstructions: "Click to download ",
        _home: "Home",
        _homebanner: "Document Library",
        _download: "Download",
        _newtab: "Open in a new tab",
        _currenthelpsetsearch: "search current helpset",
        _comments_layout_heading: "comment",
        _comments_layout_heading_plural: "comments",
        _editcomment: "edit",
        _deletecomment: "Delete",
        _commentformplaceholder: "Write a new comment...",
        _submitcomment: "Add comment",
        _updatecomment: "Update"
		}
  };

